import { render } from "./DashboardNotificationList.vue?vue&type=template&id=c12e73bc"
import script from "./DashboardNotificationList.vue?vue&type=script&lang=js"
export * from "./DashboardNotificationList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DashboardNotificationList.vue"]])

export default __exports__